module.exports = __webpack_public_path__ + "fcbfcf80f6ee7a94209bf418c6dcbc04.MP3";